import { Box, Image, useToken } from '@chakra-ui/react';
import { useColorMode } from '@/components/ui/color-mode-utils';

const taLoaderAnimation = '/gifs/TA-Loader-Animation.gif';
const taLoaderAnimationDark = '/gifs/TA-Loader-Animation-Dark.gif';

const FaceliftOverlayLoader = () => {
	const [brand600] = useToken('colors', ['brand.600']);
	const { colorMode } = useColorMode();
	const darkMode = colorMode === 'dark';

	return (
		<>
			<Box
				position="fixed"
				top={0}
				left={0}
				w="100vw"
				h="100vh"
				bg="brand.pageBackground"
				opacity={0.3}
				zIndex={9999}
			/>
			<Box
				position="fixed"
				top="50%"
				left="50%"
				transform="translate(-50%, -50%)"
				w="130px"
				h="100px"
				rounded="full"
				display="flex"
				alignItems="center"
				justifyContent="center"
				boxShadow={`0 0 25px 5px ${brand600}80`}
				bg="brand.loaderBackground"
				backdropFilter="blur(10px)"
				zIndex={10000}
			>
				<Image
					src={darkMode ? taLoaderAnimationDark : taLoaderAnimation}
					alt="TA loader animation"
					width={100}
					height={100}
				/>
			</Box>
		</>
	);
};

export default FaceliftOverlayLoader;
